import { useQuery } from "@tanstack/react-query";
import { UserProfileDto, UserRole, QuestionDto } from "@green0meter/api-client";

import { DOMAIN_DOUBLE_MATERIALITY } from "../domain";

import { roleGuard } from "@api";
import { doubleMaterialityQuestionsApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";

const allowedRoles = [UserRole.Manager, UserRole.Owner];
const ACTION_GET_QUESTION = "GET_QUESTION";

export const useGetQuestion = (
  user: UserProfileDto | null,
  id?: string,
): {
  question?: QuestionDto;
  isPendingGetQuestion: boolean;
  refetchQuestion: () => void;
  enabled: boolean;
  questionEnabled: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles) && Boolean(id);
  const fetchQuestion = async (): Promise<QuestionDto> => {
    const res =
      await doubleMaterialityQuestionsApi.doubleMaterialityQuestionsControllerGetQuestionById(
        id as string,
      );

    return res.data;
  };

  const { isPending, data, refetch } = useQuery({
    queryKey: [DOMAIN_DOUBLE_MATERIALITY, ACTION_GET_QUESTION, id],
    queryFn: fetchQuestion,
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    question: data,
    isPendingGetQuestion: isPending,
    refetchQuestion: refetch,
    enabled,
    questionEnabled: enabled,
  };
};
